export function data(state,data){
    // console.log('DATA',data);
    state.data = data
}

export function disableForm(state,data){
    state.disableForm = data
}

export function menus(state,menus){
    state.menus = menus
}

export function menusTabela(state, menusTabela){
    state.menusTabela = menusTabela
}

export function limpaData(state){
    state.disableForm = false;    
    //state.data = state.dataDefault;    
    //clonando o objeto, método acima so referencia
    state.data = JSON.parse(JSON.stringify(state.dataDefault));    
    //state.tipoMenu = {};
}

export function pagination(state,pagination){
    state.pagination = pagination
}

export function tipoMenu(state,tipoMenu){
    state.tipoMenu = tipoMenu
}

export function enumStatus(state,enumStatus){
    state.enumStatus = enumStatus
}
